import config from '@bingads-webui-component-legacy/config/index';

export const getOdataConfig = (serverContext) => {
  if (!serverContext) {
    return {
      oDataToken: config.get('odata.token'),
      oDataPath: config.get('odata.url') + config.get('odata.path'),
    };
  }
  const isLocal = () => {
    const hostname = document.location.hostname.toLowerCase();
    return hostname.indexOf('ads.microsoft.com') === -1 &&
        hostname.indexOf('ads-int.microsoft.com') === -1;
  };

  const odataPath = isLocal() ? 'Advertiser/V2' : 'Campaign/V2';

  const oDataConfig = {
    oDataToken: serverContext.Token,
    oDataPath: `${serverContext.ServicesEndpoints.CampaignAPI}${odataPath}`,
  };
  return oDataConfig;
};
